/* Count-up for [data-countup] elements. The server-rendered text is the final value,
   so no-JS and prefers-reduced-motion users see it immediately. Runs once per element. */
(function () {
  if (window.__oakCountup) return;
  window.__oakCountup = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var DURATION = 1500;

  function parse(el) {
    var m = el.textContent.trim().match(/^(\D*)(\d[\d,]*\.?\d*)(.*)$/);
    if (!m) return null;
    var dot = m[2].indexOf('.');
    return {
      pre: m[1],
      post: m[3],
      commas: m[2].indexOf(',') > -1,
      decimals: dot > -1 ? m[2].length - dot - 1 : 0,
      target: parseFloat(m[2].replace(/,/g, ''))
    };
  }

  function format(n, p) {
    var s = n.toFixed(p.decimals);
    if (p.commas) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return p.pre + s + p.post;
  }

  function run(el, p) {
    var start = null;
    function tick(t) {
      if (start === null) start = t;
      var k = Math.min((t - start) / DURATION, 1);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = format(p.target * eased, p);
      if (k < 1) requestAnimationFrame(tick);
      else el.textContent = format(p.target, p);
    }
    requestAnimationFrame(tick);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      run(e.target, e.target.__oakCount);
    });
  }, { threshold: 0.4 });

  function init(root) {
    (root || document).querySelectorAll('[data-countup]').forEach(function (el) {
      if (el.__oakCount) return;
      var p = parse(el);
      if (!p) return;
      el.__oakCount = p;
      el.textContent = format(0, p);
      io.observe(el);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
